module.exports = __webpack_public_path__ + "img/u156.02652dc6.svg";